import { useState, useEffect } from 'react'
import styles from "../../../pages/Home/ClientConfig/ClientConfig.module.css"
import * as eventManagementService from '../../../services/eventManagementService'

const HigherLogicConfig = ({
    formData,
    HigherLogicClientConfig,
    setHigherLogicClientConfig,
}) => {

    const handleChange = e => {
        setHigherLogicClientConfig({
            ...HigherLogicClientConfig,
            [e.target.name]: e.target.value,
        })
       // console.log(HigherLogicClientConfig)
    }

		const [error, setError] = useState(null)
    const errorDiv = (error)
        ?
        <ul>
            {Object.entries(error).length > 0 && Object.entries(error) &&
                Object.entries(error).map(([key, value]) => {
            //        console.log("error: " + error)
                    return <div className={value[0] === 'Test Failure' ? styles.errorMSG : styles.successMSG} key={key} >{value}</div>;
                })}
        </ul>
        : '';
    const handleTestConnection = async e => {
        e.preventDefault()
       	setError(null)
        var holder = { HigherLogicClientConfig };
        try {
            await eventManagementService.testSetup(holder)
        } catch (err) {
           // console.log(err.message)
			setError(err.internalError);
        }
    }

    const isFormValid = () => {
        return formData.ClientName
            && formData.EventRegistrationSystem
            && formData.Industry
            && formData.Categories.length > 0
            && HigherLogicClientConfig.ApiKey
            && HigherLogicClientConfig.ApiSecret
            && HigherLogicClientConfig.BaseUrl
            ? true
            : false
    }
    const isTestFormValid = () => {
        return HigherLogicClientConfig.ApiKey
            && HigherLogicClientConfig.ApiSecret
            && HigherLogicClientConfig.BaseUrl
            ? true
            : false
    }

    return (
        <>
            <div className={styles.inputContainer}>
                <label htmlFor="ApiKey" className={styles.label}>API Key: </label>
                <input
                    type="text"
                    autoComplete="off"
                    value={HigherLogicClientConfig.ApiKey}
                    name="ApiKey"
                    onChange={handleChange}
                />
            </div>

            <div className={styles.inputContainer}>
                <label htmlFor="ApiSecret" className={styles.label}>API Secret: </label>
                <input
                    type="text"
                    autoComplete="off"
                    value={HigherLogicClientConfig.ApiSecret}
                    name="ApiSecret"
                    onChange={handleChange}
                />
            </div>

            <div className={styles.inputContainer}>
                <label htmlFor="BaseUrl" className={styles.label}>Base URL: </label>
                <input
                    title="Use only URL."
                    type="text"
                    autoComplete="off"
                    value={HigherLogicClientConfig.BaseUrl}
                    name="BaseUrl"
                    onChange={handleChange}
                />
            </div>
			 {errorDiv}
            <div className={styles.inputContainer}>
                <button disabled={!isFormValid()} className={styles.button}>
                    Submit
                </button>
                <button onClick={handleTestConnection} disabled={!isTestFormValid()} className={styles.buttonRight}>
                    Test Connection
                </button>
            </div>
        </>
    );
}

export default HigherLogicConfig;